// Jeton de session de l'app native (audit sécurité C10).
// iOS : Keychain ; Android : Keystore (capacitor-secure-storage-plugin). Le jeton est gardé en mémoire
// pendant l'exécution et n'est plus écrit dans le stockage local de la WebView (lisible par un script,
// inclus dans les sauvegardes). Au premier lancement, un ancien jeton du stockage local est migré puis effacé.
// Sur le web, l'authentification repose sur le cookie HttpOnly : rien n'est stocké côté JavaScript.
import { Capacitor } from "@capacitor/core";

const KEY = "hitmax_token";
let secure = null; // module de stockage sécurisé, une fois initialisé
let memory = null;

export async function initSessionToken() {
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { SecureStoragePlugin } = await import("capacitor-secure-storage-plugin");
    let value = null;
    try { value = (await SecureStoragePlugin.get({ key: KEY })).value || null; } catch (_) { value = null; }
    let legacy = null;
    try { legacy = localStorage.getItem(KEY); } catch (_) {}
    if (!value && legacy) {
      await SecureStoragePlugin.set({ key: KEY, value: legacy });
      value = legacy;
    }
    try { localStorage.removeItem(KEY); } catch (_) {}
    memory = value;
    secure = SecureStoragePlugin;
  } catch (_) {
    secure = null; // module indisponible (ancienne version native) : repli sur le comportement précédent
  }
}

export function getSessionToken() {
  if (secure) return memory;
  try { return localStorage.getItem(KEY); } catch (_) { return null; }
}

export function setSessionToken(token) {
  if (secure) {
    memory = token || null;
    (token ? secure.set({ key: KEY, value: token }) : secure.remove({ key: KEY })).catch(() => {});
    return;
  }
  try {
    if (token) localStorage.setItem(KEY, token);
    else localStorage.removeItem(KEY);
  } catch (_) {}
}
